import { addDays } from 'date-fns';

/**
 * Gets an array of 7 days starting from the current date
 */
export const getWeekDays = (currentDate: Date): Date[] => {
  return Array.from({ length: 7 }, (_, i) => addDays(currentDate, i));
};
